import Regex from "../constants/Regex";

import processInternalUrl from "./processInternalUrl";

const isExternalUrl = url => {
    return processInternalUrl(url).match(Regex.externalUrlRegex);
};

export default isExternalUrl;
